type WebkitScrollbarSx = {
  '::-webkit-scrollbar': {
    WebkitAppearance: 'none';
    width: number | string;
    height: number | string;
  };
  '::-webkit-scrollbar-thumb': {
    borderRadius: string;
    height: number;
    backgroundColor: string;
    boxShadow: string;
  };
};

// TODO: Replace these WebKit-specific overrides with a single platform decision for scrollbars.
export const getWebkitScrollbarSx = (): WebkitScrollbarSx => ({
  '::-webkit-scrollbar': {
    WebkitAppearance: 'none',
    width: '10px',
    height: 10,
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    height: 1,
    backgroundColor: 'rgba(0, 0, 0, .3)',
    boxShadow: '0 0 1px rgba(255, 255, 255, .3)',
  },
});
